import React, { ComponentProps } from 'react';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import ILink from '../../types/ILink';
import { ContentList, ContentListItem } from '../../_lib/components/ContentList';
import { ContentHeadline } from '../../_lib/components/ContentHeadline';
import { murmurhash } from '../../lib/js/hash';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { ContentParagraph } from '../../_lib/components/ContentParagraph';
import { ContentHeadlineModifier } from '../../_lib/components/ContentHeadline/ContentHeadline';

type UserToUserRoleListItem = {
  roleName: string;
  description: string;
  editLink: ILink;
};

export type UserToUserRolesListBlockProps = {
  roles: UserToUserRoleListItem[];
};

function UserToUserRolesList({ roles }: UserToUserRolesListBlockProps) {
  const { t } = useSonTranslation('RoleList');
  if (roles?.length === 0) {
    return null;
  }

  return (
    <>
      <div className="roles-list__headline-container">
        <ContentHeadline
          title={t('userToUser')}
          hierarchy={2}
          modifier={[ContentHeadlineModifier.LARGE, ContentHeadlineModifier.NO_MARGIN_BOTTOM]}
        />
      </div>
      <ContentList ordered>
        {roles.map(roleItem => {
          return (
            <ContentListItem key={roleItem.editLink.url}>
              <ContentHeadline
                title={roleItem.roleName}
                url={roleItem.editLink.url}
                hierarchy={3}
                modifier={ContentHeadlineModifier.TOP_HEADLINE}
                headingId={`user-to-user-role-list-heading-${murmurhash(roleItem.editLink.url)}`}
              />
              <ContentParagraph>{roleItem.description}</ContentParagraph>
            </ContentListItem>
          );
        })}
      </ContentList>
    </>
  );
}

export const UserToUserRolesListBlock = asBlock(UserToUserRolesList, BlockType.usertouserroleslist);
export type UserToUserRolesListBlock = ComponentProps<typeof UserToUserRolesListBlock>;
